import React from 'react';

function TimelineItem({ time, event }) {
  return (
    <div className="timeline-item">
      <div className="scheduleTime">{time}</div>
      <div className="event">
        <h3>{event}</h3>
      </div>
    </div>
  );
}

export default TimelineItem; 